"use client";
import React, { useState } from "react";
import arrows from "../../../images/all.png"

const PeerComparison = ({peerListData}) => {
  const [cagrOverviewFilterBtn, setCagrOverviewFilterBtn] = useState("CAGR");

  const handleCagrOverViewFilter = (peer) => {
    setCagrOverviewFilterBtn(peer);
  };

  const dummyRes = [
    {
      stockName: "Parag Parikh Flexi Cap",
      oneYear: "36.4",
      threeYear: "21.8",
      fiveYear: "24.9",
      fundsize: "63934",
      expenseRatio: "0.62",
      exitLoad: "1.2",
    },
    {
      stockName: "Bank of India Flexi Cap Fund Direct Growth",
      oneYear: "70.4",
      threeYear: "29.8",
      fiveYear: null,
      fundsize: "879",
      expenseRatio: "0.77",
      exitLoad: "0.8",
    },
    {
      stockName: "JM Flexicap Fund (Direct) Growth",
      oneYear: "66.4",
      threeYear: "31.8",
      fiveYear: "25",
      fundsize: "210",
      expenseRatio: "0.48",
      exitLoad: "0.8",
    },
    {
      stockName: "Quant Flexi Cap Fund Growth Option Direct ",
      oneYear: "65.4",
      threeYear: "30.8",
      fiveYear: "33",
      fundsize: "5563",
      expenseRatio: "0.58",
      exitLoad: "1.45",
    },
  ];
  const filterCagrOptions = ["1M", "3M", "6M", "1Y", "2Y", "3Y", "5Y", "7Y"];
  const [filterCagrIndex, setFilterCagrIndex] = useState(0);

  const filterOverviewOptions = ["fundsize", "expenseRatio", "exitLoad"];
  const [filterOverviewIndex, setFilterOverviewIndex] = useState(0);

  const handleCagrFilterClick = () => {
    setFilterCagrIndex(
      (prevIndex) => (prevIndex + 1) % filterCagrOptions.length
    );
  };

  const handleOverviewFilterClick = () => {
    setFilterOverviewIndex(
      (prevIndex) => (prevIndex + 1) % filterOverviewOptions.length
    );
  };
  const currentOverviewFilter = filterOverviewOptions[filterOverviewIndex];
  const currentCagrFilter = filterCagrOptions[filterCagrIndex];

  return (
    <div className="m-4">
      <p className="font-bold text-[#262626] text-2xl mb-4">Peer Comparison</p>
      <div className="border border-solid border-[#E0E0E0] w-[361px] h-full rounded-lg p-4gap-4">
        <p className="font-bold text-[#262626] text-base m-4">
          Peer Comparison
        </p>

        <div className="flex justify-center ">
          <div className="flex w-max  border border-[#C3D5DC] items-center  gap-4  rounded-full">
            <button
              className={`text-xs font-bold pl-3 py-2 text-[#333333] ${
                cagrOverviewFilterBtn === "CAGR"
                  ? "bg-[#C3D5DC] rounded-full pr-3 pl-3 py-2"
                  : ""
              }`}
              onClick={() => handleCagrOverViewFilter("CAGR")}
            >
              CAGR
            </button>
            {/* <button
              className={`text-xs font-bold pl-1 py-2 pr-3 text-[#333333] ${
                cagrOverviewFilterBtn === "Overview"
                  ? "bg-[#C3D5DC] rounded-full pr-3 pl-3 py-2"
                  : ""
              }`}
              onClick={() => handleCagrOverViewFilter("Overview")}
            >
              Overview
            </button> */}
          </div>
        </div>

        {cagrOverviewFilterBtn === "CAGR" ? (
          <>
            <div className="flex flex-row justify-between items-center px-4 pt-4">
              <p className="font-medium text-xs text-[#8B8B8B]">Values in %</p>
              <div className="flex flex-row items-center justify-center gap-1 cursor-pointer" onClick={handleCagrFilterClick}>
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={arrows}
                    className="w-[11px] h-[11px]"
                  />
                </div>
                <div className="flex flex-col items-center justify-center mt-0.5">
                <button
                  className="text-[10px] font-bold text-[#00394d]"
                >
                  {currentCagrFilter}
                </button>
                </div>
              </div>
            </div>
            <div className="overflow-y-auto h-full">
              {peerListData && peerListData?.map((stock) => (
                <div
                  key={stock.scheme_name}
                  className="flex flex-row justify-between px-4 items-center my-4"
                >
                  {/* <img src="dummy.png" alt="" className="w-[25px] h-[25px]" /> */}
                  <p className="font-semibold text-sm text-[#333333] w-[220px]">
                    {stock.scheme_name}
                  </p>
                  <p className="font-bold text-xs text-[#333333]">
                    {stock?.returns[filterCagrIndex] && Object.values(stock?.returns[filterCagrIndex]) !== null
                      ? `${Object.values(stock?.returns[filterCagrIndex])}%`
                      : "--"}
                  </p>
                </div>
              ))}
            </div>
          </>
        ) : cagrOverviewFilterBtn === "Overview" ? (
          <>
            {" "}
            <div className="flex flex-row justify-between items-center px-4 pt-4">
              <p className="font-medium text-xs text-[#8B8B8B]">values in %</p>
              <div className="flex flex-row gap-1">
                <div className="flex flex-col items-center ">
                  <img
                    src="/images/uparrow.png"
                    className="w-[11px] h-[11px]"
                  />
                  <img
                    src="/images/downarrow.png"
                    className="w-[11px] h-[11px] ml-[2px]"
                  />
                </div>

                <button
                  className="text-[10px] font-bold text-[#00394d]"
                  onClick={handleOverviewFilterClick}
                >
                  {currentOverviewFilter === "fundsize"
                    ? "Fund Size"
                    : currentOverviewFilter === "expenseRatio"
                    ? "Expense Ratio"
                    : "Exit Load"}
                </button>
              </div>
            </div>
            <div>
              {dummyRes.map((stock) => (
                <div
                  key={stock.stockName}
                  className="flex flex-row justify-between px-4 items-center my-4"
                >
                  {/* <img src="dummy.png" alt="" className="w-[25px] h-[25px]" /> */}
                  <p className="font-semibold text-sm text-[#333333] w-[220px]">
                    {stock.stockName}
                  </p>
                  <p className="font-bold text-xs text-[#333333]">
                    {/* {stock[currentOverviewFilter]}% */}
                    {currentOverviewFilter === "fundsize"
                      ? `${stock[currentOverviewFilter]}cr`
                      : `${stock[currentOverviewFilter]}%`}
                  </p>
                </div>
              ))}
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default PeerComparison;
